// Team of Enactus 6.0 imports
// import Prachi from "../../Assets/Members/Prachi.jpeg";
// import Janit from "../../Assets/Members/Janit.jpg";
// import Harsh from "../../Assets/Members/Harsh.jpeg";
// import Sparsh from "../../Assets/Members/Sparsh.jpeg";
// import Navya from "../../Assets/Members/Navya.jpeg";
// import aditya from "../../Assets/Members/aditya.jpeg";
// import sakshi from "../../Assets/Members/sakshi.jpeg";
// import tushar from "../../Assets/Members/tushar.jpeg";
// import anushka from "../../Assets/Members/anushka.jpeg";
// import simran from "../../Assets/Members/simran.jpeg";
// import Devanshi from "../../Assets/Members/Devanshi.jpeg"

// Team of enactus 7.0 imports
// import Vansh from "../../Assets/Members-7.0/Vansh Wadhwa.jpeg";
// import Pankhuri from "../../Assets/Members-7.0/Pankhuri.jpeg";
// import Akshit from "../../Assets/Members-7.0/Akshit Saxena.JPG";
// import Devangi from "../../Assets/Members-7.0/Devangi Bedi.jpg";
// import Anushka from "../../Assets/Members-7.0/Anushka Khanduri.jpeg";
// import Devansh from "../../Assets/Members-7.0/Devansh Arya .jpg";
// import Himanshi from "../../Assets/Members-7.0/Himanshi Gaur.JPG";
// import Manish from "../../Assets/Members-7.0/Manish .jpg";
// import Rajdeep from "../../Assets/Members-7.0/Rajdeep Bose.jpg";
// import Simran from "../../Assets/Members-7.0/Simran Dhankar.jpeg";
// import Sneha from "../../Assets/Members-7.0/Sneha Jain.jpeg";
// import Tanishka1 from "../../Assets/Members-7.0/Tanishka Gaur.JPG";
// import Tisha from "../../Assets/Members-7.0/Tisha Singhal.jpg";
// import Tripti from "../../Assets/Members-7.0/Tripti Bhardwaj.png";
// import Trisha from "../../Assets/Members-7.0/Trisha Bhatia.jpg";
// import Vibhor1 from "../../Assets/Members-7.0/Vibhor jain.jpg";
// import Yashi from "../../Assets/Members-7.0/Yashi Tomar.JPG";

// Team of enactus 7.0 imports
import sameer from "../img/sameer.jpg";
import sonika from "../img/sonika.jpeg.jpg";
import ansh from "../img/ansh.jpg";
import gayatri from "../img/gayatri.jpg";
import Samyak from "../img/samyak.jpeg.jpg";
import sahil from "../img/sahil.jpeg.jpg";
import Ramish from "../img/ramish.jpeg.jpg";
import Shreya  from "../img/shreya.jpg";
import aarav  from "../img/aarav.jpeg.jpg";


const Data = [
  {
    image: sameer,
    name: "Sameer Khan",
    position: "Department Head(Technical Department)",
  },
  {
    image: sonika,
    name: "Sonika Nautiyal",
    position: "Department Head(Marketing & Campaign)",
  },
  {
    image: ansh,
    name: "Ansh Varshney",
    position: "Department Head (Graphics & Photography)",
  },
  {
    image: gayatri,
    name: "Gayatri Singh",
    position: "Department Head (Social Media)",
  },
  {
    image: aarav,
    name: "Aarav Bamba",
    position: "Department Head (Research and Content)",
  },
  {
    image: Samyak,
    name: "Samyak Bhat",
    position: "Department Head (Sponsorships)",
  },
  {
    image: sahil,
    name: "Sahil Gupta",
    position: "Project Head (Navodaya)",
  },
  {
    image: Ramish,
    name: "Ramish",
    position: "Project Head (Vriksh)",
  },
  {
    image: Shreya ,
    name: "Shreya",
    position: "Project Head (Initiative Astitva)",
  },
];
export default Data;


// Council of  Enactus 6.0 
// const Data6 = [
//   {
//     image: Janit,
//     name: "Janit Chawla",
//     position: "Department Head(Technical Department)",
//   },
//   {
//     image: anushka,
//     name: "Anushka Khanduri",
//     position: "Department Head(Marketing & Campaign)",
//   },
//   {
//     image: Harsh,
//     name: "Harshvardhan Sharma",
//     position: "Department Head (Graphics & Photography)",
//   },
//   {
//     image: Prachi,
//     name: "Prachi Malik",
//     position: "Department Head (Social Media)",
//   },
//   {
//     image: sakshi,
//     name: "Sakshi Goel",
//     position: "Department Head (Content)",
//   },
//   {
//     image: Sparsh,
//     name: "Sparsh Girdhar",
//     position: "Department Head (Sponsorships)",
//   },
//   {
//     image: Navya,
//     name: "Navya Malik",
//     position: "Department Head(Business Development)",
//   },
//   {
//     image: aditya,
//     name: "Aditya Aggarwal",
//     position: "Project Head (Mritkala)",
//   },
//   {
//     image: simran,
//     name: "Simran Dhankar",
//     position: "Project Head (Abeer)",
//   },
//   {
//     image: tushar,
//     name: "Tushar Kapoor",
//     position: "Project Head (Abeer)",
//   },
// ];

// Council of  Enactus 7.0 
// const Data = [
//   {
//     image: Vansh,
//     name: "Vansh Wadhwa",
//     position: "Department Head(Technical Department)",
//   },
//   {
//     image: Vibhor1,
//     name: "Vibhor",
//     position: "Department Head(Marketing & Campaign)",
//   },
//   {
//     image: Tisha,
//     name: "Tisha Singhal",
//     position: "Department Head(Marketing & Campaign)",
//   },
//   {
//     image: Himanshi,
//     name: "Himanshi Gaur",
//     position: "Department Head (Graphics & Photography)",
//   },
//   {
//     image: Manish,
//     name: "Manish Bobade",
//     position: "Department Head (Graphics & Photography)",
//   },
//   {
//     image: Sneha,
//     name: "Sneha Jain",
//     position: "Department Head (Social Media)",
//   },
//   {
//     image: Pankhuri,
//     name: "Pankhuri",
//     position: "Department Head (Content)",
//   },
//   {
//     image: Tanishka1,
//     name: "Tanishka Gaur",
//     position: "Department Head (Sponsorships)",
//   },
//   {
//     image: Tripti,
//     name: "Tripti Bhardwaj",
//     position: "Department Head(Business Development)",
//   },
//   {
//     image: Rajdeep,
//     name: "Rajdeep Bose",
//     position: "Department Head(Business Development)",
//   },

//   {
//     image: Tripti,
//     name: "Tripti Bhardwaj",
//     position: "Project Head (Navodaya)",
//   },
//   {
//     image: Sneha,
//     name: "Sneha Jain",
//     position: "Project Head (Navodaya)",
//   },
//   {
//     image: Akshit,
//     name: "Akshit Saxena",
//     position: "Project Head (Vriksh)",
//   },
//   {
//     image: Devangi,
//     name: "Devangi Bedi",
//     position: "Project Head (Vriksh)",
//   },
//   {
//     image: Trisha,
//     name: "Trisha Bhatia",
//     position: "Project Head (Initiative Astitva)",
//   },
// ];
